/* eslint-disable */
import PropTypes from 'prop-types';
import app from "new-ui/app";
import { EDIT_QUESTION_POPUP_ACTION_SOURCE } from 'utils/constants/actionSource';
import { useObjectRef } from 'utils/hooks/useObjectRef';
import './EditQuestion.css';
import { Intake, EXPAND_ALL } from 'new-ui/Components/Intake/Intake';
import { waitFor } from "new-ui/functions";
import React, { useEffect, useRef } from "react";
import { render } from "react-dom";

const EditQuestion = ({ question, onClose }) => {
    const $ = useRef();
    const onCloseRef = useObjectRef(onClose);

    useEffect(()=>{
        const fetch = async ()=>{
            const customQuestions = [question];
            waitFor(()=>{
                return app.user
            }, ()=>{
                render(
                    <Intake
                        id="editQuestionPopup"
                        className="single-question-intake"
                        user={app.user}
                        flatMode
                        expand={EXPAND_ALL}
                        targetQuestions={customQuestions}
                        onUpdate={() => {
                          app.handleUserUpdate({ actionSource: EDIT_QUESTION_POPUP_ACTION_SOURCE });
                        }}
                        gotoResults={()=>{
                            app.closePopups();
                        }}
                    />,
                    $.current,
                )
            }, ()=>{

            })
        }
        fetch();
    }, []);

    useEffect(() => () => {
        if (onCloseRef.current) {
            onCloseRef.current();
        }
    }, [onCloseRef]);

    return <div ref={$} className="edit-question-popup"></div>
};

EditQuestion.propTypes = {
    question: PropTypes.string.isRequired,
    onClose: PropTypes.func,
};

export default EditQuestion;
